module.exports = __webpack_public_path__ + "static/images/details-2.348fb9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product/zfb/details-2.png
// module id = 95Bg
// module chunks = 0